import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'Gut Health Nerve Restoration';
render(<App data-id="element-270" />, document.getElementById('root'));